export default "__VITE_ASSET__BFfpc6pX__"